import { render, staticRenderFns } from "./APIChannels.vue?vue&type=template&id=5cf3b113&scoped=true"
import script from "./APIChannels.vue?vue&type=script&lang=js"
export * from "./APIChannels.vue?vue&type=script&lang=js"
import style0 from "./APIChannels.vue?vue&type=style&index=0&id=5cf3b113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3b113",
  null
  
)

export default component.exports